import { Plugin } from 'ckeditor5/src/core';
import { addToolbarToDropdown, ButtonView, createDropdown } from 'ckeditor5/src/ui';
import OpenscopIcons from './openscopicons';
import IconView from './IconElement';
export default class OpenscopIconsUI extends Plugin {
    init() {
        const editor = this.editor;
        // The button must be registered among the UI components of the editor
        // to be displayed in the toolbar.
        editor.ui.componentFactory.add(OpenscopIcons.pluginName, () => {
            const dropdownView = createDropdown(editor.locale);
            const icons = editor.config.get(`${OpenscopIcons.pluginName}.icons`);
            addToolbarToDropdown(dropdownView, generateIcons(editor, icons));
            dropdownView.buttonView.set({
                label: 'Icônes',
                withText: true,
                class: ''
            });
            this.listenTo(dropdownView, 'execute', event => {
                const button = event.source;
                editor.execute('openscopInsert', { icon: button.iconClass });
            });
            return dropdownView;
        });
    }
}
function generateIcons(editor, iconsList) {
    const items = [];
    for (const icon of iconsList) {
        const definition = new ButtonView();
        definition.label = icon;
        definition.iconClass = icon;
        definition.withText = false;
        const iconElement = new IconView(editor.locale, icon);
        definition.children.add(iconElement);
        items.push(definition);
    }
    return items;
}
